import {
  Box,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography
} from '@mui/material';
import React, { useCallback, useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import RetryIcon from '@mui/icons-material/Replay';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  billTransaction,
  SEND_TO_REBILL
} from 'src/store/actions/billingActions';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import { TransactionsType } from 'src/utils/constants/transactions';
import RebillTransactionDialog from './RebillTransactionDialog/RebillTransactionDialog';

const BillingFailureRowMenu = ({ id, transactionType }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const isLoadingRebill = useSelector(
    isLoadingSelector([SEND_TO_REBILL.action])
  );

  const handleOpenConfirmationDialog = () => {
    setOpenConfirmationDialog(true);
  };
  const handleCloseConfirmationDialog = () => {
    setOpenConfirmationDialog(false);
  };

  const handleOpenMenu = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleRetry = useCallback(() => {
    dispatch(billTransaction(id, handleCloseConfirmationDialog));
    return handleCloseMenu();
  }, [id]);

  return (
    <Box component="div">
      <IconButton
        aria-label="documentsMenu"
        id="documentsMenu"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        onClick={handleOpenMenu}
      >
        <MoreVertIcon />
      </IconButton>

      <Menu
        id={id}
        MenuListProps={{
          'aria-labelledby': 'long-button'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        PaperProps={{
          sx: {
            width: '27ch',
            bgcolor: 'background.paper',
            color: 'text.primary',
            boxShadow: 1
          }
        }}
      >
        <MenuItem onClick={handleOpenConfirmationDialog}>
          <ListItemIcon>
            <RetryIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="inherit">
            {t('TRANSACTION.SEND_TO_REBILL')}
          </Typography>
        </MenuItem>
      </Menu>
      <RebillTransactionDialog
        open={openConfirmationDialog}
        onClose={handleCloseConfirmationDialog}
        onSubmit={handleRetry}
        isLoading={isLoadingRebill}
        title={t('COMMON.REBILL_TRANSACTION_TITLE')}
        chargeDescription={t('COMMON.REBILL_TRANSACTION_DESCRIPTION')}
        transactionType={transactionType}
      />
    </Box>
  );
};

BillingFailureRowMenu.propTypes = {
  id: PropTypes.string.isRequired,
  transactionType: PropTypes.oneOfType([
    TransactionsType.CHARGE,
    TransactionsType.PAYMENT
  ])
};

export default BillingFailureRowMenu;
